export default "__VITE_ASSET__P_XjQcbv__"